import { Navigate, useParams } from 'react-router-dom';
import { buildAffiliateRedirectUrl, persistAffiliateCode } from '../../utils/affiliateLink';

export default function AffiliateRedirect({ to, extraParams = {} }) {
    const { affiliateCode } = useParams();
    persistAffiliateCode(affiliateCode);
    return <Navigate to={buildAffiliateRedirectUrl(to, affiliateCode, extraParams)} replace />;
}
